/**
 * Created by Denis Kuzin on 15 march 2022
 */

const ClanConfirmActionWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        this._super({
            name: "ClanConfirmActionWindow",
            title: options.title,
            content: this.createContent(),
            closeButton: false
        });

        this.action = options.action;
    },

    createContent: function () {
        const styles = cleverapps.styles.ClanConfirmActionWindow;

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles);

        const text = this.createText();
        const buttons = this.createButtons();

        const items = new cleverapps.Layout([text, buttons], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        content.addChild(items);
        items.setPosition(content.width / 2, content.height / 2);

        return content;
    },

    createText: function () {
        const styles = cleverapps.styles.ClanConfirmActionWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get("AreYouSure"), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setAnchorPoint(0.5, 0.5);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, styles.text.height);

        return text;
    },

    createButtons: function () {
        const styles = cleverapps.styles.ClanConfirmActionWindow;

        const noButton = new cleverapps.UI.Button({
            text: Messages.get("No"),
            onClicked: this.close.bind(this),
            width: styles.button.width,
            height: styles.button.height
        });

        const yesButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("Yes"),
            onClicked: function () {
                this.action();
            }.bind(this),
            width: styles.button.width,
            height: styles.button.height
        });

        return new cleverapps.Layout([yesButton, noButton], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    }
});

cleverapps.styles.ClanConfirmActionWindow = {
    width: 700,
    height: 270,
    margin: 40,

    text: {
        width: 500,
        height: 150
    },

    button: {
        width: 300,
        height: 100
    }
};